import client from "./sharedoClient";

const getAll = () => client.get("api/admin/docGen/templates/_tags");

export default {
    getAll
}